import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import MapTo from "../utils/mapto"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"
import useAppContext from "../hooks/useAppContext"

const ContentfulPage = ({ data }) => {
	const { contentfulPageHcp, allContentfulCardAssembly } = data;
	const { initResources, filteredResources } = useAppContext();

	// Create a state to hold a mutable deep copy of contentfulPage
	const [pageContent, setPageContent] = useState(() => {
		// Deep clone the contentfulPage on first render
		return JSON.parse(JSON.stringify(contentfulPageHcp));
	});
  
	// Initialize resources with default processing
	useEffect(() => {
		// Set alternating background colors for resources
		const coloredResources = allContentfulCardAssembly.nodes.map((node, index) => ({
			...node,
		}));

		// Initialize resources in the app context
		initResources(coloredResources);
	}, [allContentfulCardAssembly.nodes]);
  
	// Update content structure when filtered resources change
	useEffect(() => {
		// Update content structure with filtered resources
		if (pageContent?.content?.[1]?.items?.[3]?.items?.[0] && filteredResources?.length > 0) {
			// Create a new deep copy of the entire page content
			const updatedPageContent = JSON.parse(JSON.stringify(pageContent));

			// Update the specific nested items with filtered resources
			updatedPageContent.content[1].items[3].items[0].items = filteredResources;

			// Update the state to trigger a re-render
			setPageContent(updatedPageContent);
		}
	}, [filteredResources]);
  
	// Set document title and meta description effect
	useEffect(() => {
	// Set page title
		if (pageContent?.pageTitle) {
			document.title = pageContent.pageTitle;
		}

		// Set meta description
		if (pageContent?.pageDescription?.raw) {
			const plainTextDescription = documentToPlainTextString(
				JSON.parse(pageContent.pageDescription.raw)
			);

			let metaDescription = document.querySelector('meta[name="description"]');

			if (metaDescription) {
				metaDescription.setAttribute('content', plainTextDescription);
			} else {
				metaDescription = document.createElement('meta');
				metaDescription.setAttribute('name', 'description');
				metaDescription.setAttribute('content', plainTextDescription);
				document.head.appendChild(metaDescription);
			}
		}
	}, [pageContent]);
  
	return (
		<Layout 
			header={pageContent?.header}
			backgroundColor={pageContent?.backgroundColor}
			isi={{ isi: pageContent?.isi, importantSafetyInformation: pageContent?.importantSafetyInformation, indication: pageContent?.indication }}
			references={pageContent?.references}
			isResourcesPage={true}
		>
			{pageContent?.content?.map(item => (
				<MapTo key={item.id} items={item} />
			))}
		</Layout>
	)
}

export const query = graphql`  query($id: String!) {
    allContentfulCardAssembly(
      filter: {metadata: {tags: {elemMatch: {name: {eq: "ExparelResources"}}}}}
    ) {
      totalCount
      nodes {
        metadata {
          tags {
            name
          }
        }
        items {
          ... on ContentfulLink {
            ...CTAFragment
          }
          ... on ContentfulMedia {
            ...ContentfulMediaFragment
          }
          ... on ContentfulRichText {
            ...ContentfulRichTextFragment
          }
		  ... on ContentfulVideo {
            ...ContentfulVideoFragment
          }
        }
        id
        __typename
        entryTitle
        type
        backgroundColor
        backgroundShadow
        borderRadius
        borderRadiusTop
        borderRadiusBottom
      }
    }

    contentfulPageHcp(id: { eq: $id }) {
      id
      entryTitle
      pageTitle
      pageDescription {
        __typename
        raw
      }
      slug
      backgroundColor
		content {
			...ContentfulPageContentItemFragment
		}
		isi {
			...ContentfulRichTextFragment
		}
		references {
			...ContentfulRichTextFragment
		}
		importantSafetyInformation{
			...ContentfulRichTextFragment
		}
		indication{
			...ContentfulRichTextFragment
		}
		header

    }
  }
`

export default ContentfulPage
